import { render, staticRenderFns } from "./AlmuerzosListaItem.vue?vue&type=template&id=6009f926&"
import script from "./AlmuerzosListaItem.vue?vue&type=script&lang=js&"
export * from "./AlmuerzosListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports